import {faLock} from "@fortawesome/pro-solid-svg-icons/faLock";
import {faShieldHalved} from "@fortawesome/pro-solid-svg-icons/faShieldHalved";
import {faUsers} from "@fortawesome/pro-solid-svg-icons/faUsers";
import {faUserSecret} from "@fortawesome/pro-solid-svg-icons/faUserSecret";
import {ColourSolid} from "@twigsby/frontend-framework";
import {ChangePassword} from "../../Pages/User/Security/ChangePassword";
import LoginHistory from "../../Pages/User/Security/LoginHistory";
import {SubAccounts} from "../../Pages/User/Security/SubAccounts";
import TwoFactor from "../../Pages/User/Security/TwoFactor";
import {SuggestibleRouteInterface} from "../TopRoutes";

const SecurityRoutes: Array<SuggestibleRouteInterface> = [
    {
        title: 'Login History',
        path:'/manage-account/security/login-history',
        icon: faUserSecret,
        element: <LoginHistory />,
        colour: ColourSolid.Alert,
        group: 'Login & Security'
    },
    {
        title: 'Change Password',
        path:'/manage-account/security/password',
        element: <ChangePassword />,
        icon: faLock,
        colour: ColourSolid.Alert,
        group: 'Login & Security'
    },
    {
        title: 'Two Factor Auth (2FA)',
        path:'/manage-account/security/2fa',
        icon: faShieldHalved,
        element: <TwoFactor />,
        colour: ColourSolid.Alert,
        group: 'Login & Security'
    },
    {
        title: 'Sub-Accounts',
        path:'/manage-account/security/sub-accounts',
        element: <SubAccounts />,
        icon: faUsers,
        colour: ColourSolid.Alert,
        group: 'Login & Security'
    },
]

export { SecurityRoutes }
